import { render } from "./CreateTrivia.vue?vue&type=template&id=219f7e0e&scoped=true"
import script from "./CreateTrivia.vue?vue&type=script&lang=js"
export * from "./CreateTrivia.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=219f7e0e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219f7e0e"]])

export default __exports__